import { combineReducers } from 'redux';

import translations from './translations';
import dexfSettings from './dexfSettings';
import dialog from './dialog';
import init from './init';
import navigation from './navigation';
import popups from './popups';
import scene from './scene';
import sprs from './sprs';
import tac from './tac';
import userAgent from './userAgent';
import vpc from './vpc';
import screensaver from './screensaver';
import productMenu from './productMenu';
import ymal from './ymal';
import products from './products';
import { State } from './StateTypes';
import stores from './stores';
import summary from './summary';
import rawData from './rawData';
import rangeData from './rangeData';
import draft from './draft';
import sheets from './sheets';
import toasts from './toasts';

const state: State = {
  // @ts-ignore
  translations,
  // @ts-ignore
  dexfSettings,
  // @ts-ignore
  dialog,
  // @ts-ignore
  init,
  // @ts-ignore
  navigation,
  // @ts-ignore
  popups,
  // @ts-ignore
  productMenu,
  // @ts-ignore
  scene,
  // @ts-ignore
  screensaver,
  // @ts-ignore
  sprs,
  // @ts-ignore
  tac,
  // @ts-ignore
  userAgent,
  // @ts-ignore
  vpc,
  // @ts-ignore
  ymal,
  // @ts-ignore
  products,
  stores,
  // @ts-ignore
  summary,
  // @ts-ignore
  sheets,
  // @ts-ignore
  rawData,
  // @ts-ignore
  rangeData,
  // @ts-ignore
  draft,
  // @ts-ignore
  toasts,
};

// @ts-ignore
export default combineReducers(state);
